<template>
  <div class="internal-bady" :dir="pageDirection" :lang="pageLanguage">
    <WhatsappChet />
    <NavBar />
    <div id="top"></div>

    <section class="after-first-ride-section px-3 px-md-4">
      <div class="container">
        <div class="after-first-ride-success-wrap">
          <span class="after-first-ride-success-icon"><i class="fa-solid fa-circle-check"></i></span>
          <p class="after-first-ride-success mb-0">{{ t("afterFirstRideSuccess") }}</p>
        </div>
        <h1 class="after-first-ride-title">{{ t("afterFirstRideTitle") }}</h1>
        <p class="after-first-ride-subtitle">
          {{ t("afterFirstRideSubtitle") }}
        </p>

        <h2 class="after-first-ride-steps-heading">{{ t("afterFirstRideStepsHeading") }}</h2>
        <div class="row justify-content-center g-3 g-md-4 mb-5 after-first-steps-row">
          <div class="col-md-4">
            <div
              class="after-step-card after-step-card-clickable"
              role="button"
              tabindex="0"
              :aria-label="t('afterFirstRideCta')"
              @click="goToRide"
              @keydown.enter.prevent="goToRide"
              @keydown.space.prevent="goToRide"
            >
              <div class="after-step-num">1</div>
              <p class="after-step-label mb-0">{{ t("afterFirstRideStep1Label") }}</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="after-step-card">
              <div class="after-step-num">2</div>
              <p class="after-step-label mb-0">{{ t("afterFirstRideStep2Label") }}</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="after-step-card">
              <div class="after-step-num">3</div>
              <p class="after-step-label mb-0">{{ t("afterFirstRideStep3Label") }}</p>
            </div>
          </div>
        </div>

        <div class="after-first-ride-video-wrap mb-5">
          <h2 class="after-first-ride-steps-heading mb-3">{{ t("afterFirstRideVideoHeading") }}</h2>
          <div class="after-first-video-container">
            <video
              :src="tutorialVideoUrl"
              controls
              class="after-first-ride-video"
              preload="metadata"
              playsinline
            >
              {{ t("afterFirstRideVideoNoSupport") }}
            </video>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-primary after-first-ride-cta fw-semibold"
            @click="goToRide"
          >
            {{ t("afterFirstRideCta") }}
          </button>
        </div>
      </div>
    </section>

    <PageFooterNew />
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import PageFooterNew from "@/components/PageFooterNew.vue";
import WhatsappChet from "@/components/WhatsappChet";
import { translationMixin } from "@/mixins/translationMixin";

export default {
  name: "AfterFirstRide",
  mixins: [translationMixin],
  components: {
    NavBar,
    PageFooterNew,
    WhatsappChet,
  },
  data() {
    return {
      tutorialVideoUrl: "https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/tutorials%2Fadding_new_atraction_base_5.mp4?alt=media&token=2aaaf1d8-4cfa-42f9-89b3-3010f7d3d86c",
    };
  },
  mounted() {
    localStorage.setItem('onboardingActive', '1');
  },
  computed: {
    pageLanguage() {
      return this.getCurrentLanguage === "he" ? "he" : "en";
    },
    pageDirection() {
      return this.getCurrentLanguage === "he" ? "rtl" : "ltr";
    },
    rideId() {
      return this.$route.params.rideId;
    },
  },
  methods: {
    goToRide() {
      if (this.rideId) {
        localStorage.setItem("workAroundToSetTheScroleLocationAtTheMAinPage", "0");
        this.$router.push({
          path: "/single_ride_with_map/" + this.rideId,
          query: { scrollToDay: "0", onboarding: "true" },
        });
      } else {
        this.$router.push("/user_rides");
      }
    },
  },
};
</script>

<style scoped>
.internal-bady {
  line-height: 1.5;
}

.after-first-ride-section {
  padding-top: 120px;
  padding-bottom: 4rem;
}

.after-first-ride-success-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1.5rem 2rem;
  margin-bottom: 2rem;
  background: linear-gradient(135deg, rgba(52, 208, 182, 0.2), rgba(7, 160, 195, 0.2));
  border-radius: 16px;
  border: 2px solid rgba(7, 160, 195, 0.4);
}

.after-first-ride-success-icon {
  font-size: 3.2rem;
  color: #07A0C3;
  flex-shrink: 0;
}

.after-first-ride-success {
  font-size: 2.6rem;
  font-weight: 800;
  text-align: center;
  color: #0D2F29;
  margin: 0;
}

.after-first-ride-title {
  font-size: calc(2.8rem + 1.5vw);
  font-weight: 800;
  text-align: center;
  background: linear-gradient(135deg, #34D0B6, #07A0C3);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent !important;
  margin-bottom: 1rem;
}

.after-first-ride-subtitle {
  font-size: 2rem;
  font-weight: 600;
  text-align: center;
  color: #1e1e1e;
  margin-bottom: 3rem;
  line-height: 1.6;
}

.after-first-ride-steps-heading {
  font-size: calc(2.2rem + 1vw);
  font-weight: 700;
  text-align: center;
  color: #1e1e1e;
  margin-bottom: 2rem;
}

.after-step-card {
  padding: 2rem 1.5rem;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(7, 160, 195, 0.12);
  text-align: center;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.after-step-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 28px rgba(7, 160, 195, 0.18);
}

.after-step-card-clickable {
  cursor: pointer;
}

.after-step-card-clickable:focus {
  outline: 2px solid #07a0c3;
  outline-offset: 2px;
}

.after-step-num {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #34D0B6, #07A0C3);
  color: white;
  font-weight: 800;
  font-size: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
}

.after-step-label {
  font-size: 1.6rem;
  font-weight: 600;
  color: #1e1e1e;
}

.after-first-ride-cta {
  padding: 18px 48px;
  font-size: 2.2rem !important;
  border-radius: 14px !important;
  background: linear-gradient(45deg, #34D0B6, #07A0C3);
  color: white;
  border: 0;
}

.after-first-ride-cta:hover {
  background: linear-gradient(45deg, #39e1c5, #08add3);
  color: white;
}

.after-first-ride-video-wrap {
  text-align: center;
}

.after-first-video-container {
  position: relative;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(7, 160, 195, 0.15);
  background: #000;
}

.after-first-video-container::before {
  content: "";
  display: block;
  padding-top: 56.25%;
}

.after-first-ride-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@media (max-width: 575.98px) {
  .after-first-ride-section {
    padding-top: 96px;
  }

  .after-first-steps-row > [class*="col-"] {
    margin-bottom: 1.5rem;
  }

  .after-first-steps-row > [class*="col-"]:last-child {
    margin-bottom: 0;
  }
}
</style>
